export default {
  path: 'event-and-training',
  component: () => import('@/views/Route'),
  children: [
    {
      path: '',
      name: 'Event and Training',
      component: () => import('@/views/menus/eventAndTraining/Index'),
      meta: {
        permission: true
      }
    }
  ]
}
